var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 18,
    height: 17,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.125 0H4.875C2.182 0 0 2.182 0 4.875V21.125C0 23.818 2.182 26 4.875 26H21.125C23.818 26 26 23.818 26 21.125V4.875C26 2.182 23.818 0 21.125 0ZM18.78 17.394L17.392 18.781C17.138 19.036 16.722 19.036 16.468 18.781L13 15.313L9.533 18.78C9.278 19.035 8.863 19.035 8.608 18.778L7.22 17.394C6.967 17.138 6.967 16.725 7.22 16.468L10.688 13.001L7.221 9.534C6.967 9.278 6.967 8.862 7.221 8.609L8.609 7.221C8.864 6.964 9.28 6.964 9.534 7.221L13 10.689L16.468 7.221C16.723 6.964 17.139 6.964 17.392 7.221L18.78 8.607C19.034 8.862 19.034 9.278 18.781 9.534L15.313 13.001L18.781 16.468C19.033 16.725 19.033 17.138 18.78 17.394Z",
    fill: "#0F1620"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.dbe8c73b.svg";
export { ForwardRef as ReactComponent };